import React from 'react';
import { campaignProgressStatusesDataSource } from 'infrastructure/data-sources/campaign-statuses';
import BaseTag from 'components/atoms/base-tag';
import { useTranslation } from 'react-i18next';
import { Popover } from 'antd';
import { CampaignProgressStatus } from 'infrastructure/enums';
import { SMS_ERROR_CODES } from 'infrastructure/consts';

import s from './styles.module.scss';

interface IProps {
  status: CampaignProgressStatus | null;
  errorCode: string | null;
}

const CampaignStatusCol: React.FC<IProps> = ({ status, errorCode }) => {
  const { t } = useTranslation();
  const campaignStatus = campaignProgressStatusesDataSource(false).find(
    (el) => el.id === status,
  );

  let content = null;
  if (status === CampaignProgressStatus.Failed) {
    const text =
      errorCode === SMS_ERROR_CODES.MANUAL_DISABLED_SMS_CODE
        ? t('smsCampaign.notSendManuallyDisabledErrorMessage')
        : t('smsCampaign.notSendErrorMessage', { errorCode });
    content = (
      <p
        className={s['error-text']}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  return (
    <Popover
      placement="topLeft"
      trigger="hover"
      content={content}
      getPopupContainer={(trigger) => trigger}
      arrow={false}
    >
      <div>
        <BaseTag
          label={campaignStatus?.name || t('campaignStatuses.notStarted')}
          color={campaignStatus?.color}
          width="105px"
          size="large"
          transparent
          className={s.tag}
        />
      </div>
    </Popover>
  );
};

export default CampaignStatusCol;
